<template>
  <transition name="fade">
    <box v-show="transitionShow" style="width:60vw;height: 50vh">
      <template v-slot:body>
        <!-- <img src="@/assets/lin-1.png" class="box-lin" /> -->
        <img src="@/assets/facing-left.gif" class="box-lin" />
        <div class="main">
          <p class="main-header">&nbsp;是否要和小林通訊？</p>
        </div>
        <div class="bottom">
          <action
            action-class="yellow"
            :isDisable="isDisable"
            text="否"
            @goNext="$router.push('/')"
          ></action>
          <action
            action-class="yellow"
            :isDisable="isDisable"
            style="margin-left: 2em;"
            text="是"
            @goNext="goNext"
          ></action>
          <lottie
            v-if="show"
            class="dial"
            :options="defaultOptions"
            :height="150"
            :width="150"
            v-on:animCreated="handleAnimation"
          />
        </div>
      </template>
    </box>
  </transition>
</template>
<script>
import Box from "@/components/Box";
import Action from "@/components/Action.vue";
import Lottie from "./lottie.vue";
import animationData from "@/assets/dial.json";

export default {
  components: { Box, Action, Lottie },
  data() {
    return {
      defaultOptions: { animationData: animationData },
      animationSpeed: 100,
      show: false,
      isDisable: false,
      transitionShow: false
    };
  },
  mounted() {
    setTimeout(() => {
      this.transitionShow = true;
    }, 300);
  },
  methods: {
    goNext() {
      this.show = true;
      this.isDisable = true;
      setTimeout(() => {
        this.$router.push("who");
      }, 3000);
    },
    handleAnimation: function(anim) {
      this.anim = anim;
      this.anim.setSpeed(2);
    }
  }
};
</script>
<style lang="scss" scoped>
.main {
  margin-top: 5em;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  .main-header {
    margin-top: 1.2em;
    font-size: 2em;
    font-weight: bold;
    color: #965151;
    white-space: pre;
    display: inline-block;
    border: 1px solid transparent;
    border-width: 0 0 3px 0;
    border-image: linear-gradient(
      90deg,
      #965151 50%,
      rgba(150, 81, 81, 0.0224164) 104.35%,
      rgba(150, 81, 81, 0) 105.59%
    );
    border-image-slice: 1;
  }
}
.bottom {
  margin-top: 2.5em;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.box-lin {
  position: absolute;
  bottom: -8em;
  right: -4em;
  height: 18vw;
}
.dial {
  position: absolute;
  right: 5em;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
